import { ReactElement, useMemo } from 'react'
import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

import Meta from '@/components/base/Meta'
import Builder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import usePagePrecache from '@/hooks/usePagePrecache'
import { getPromiseFromFetch } from '@/utils/request'
import { API } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, [])

  const output = useMemo(() => {
    return (
      <div data-builder className="relative z-10">
        <Builder pageData={pageData} />
      </div>
    )
  }, [pageData])

  return output
}

Page.getLayout = function getLayout(page: ReactElement, props: WPPageData) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  params,
  locale,
  defaultLocale
}: GetStaticPropsContext<{ routes: string[] }>) {
  const res = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale === defaultLocale ? '' : `${locale}/`}${params?.routes.join('/')}/`
  })

  const { data: pageData } = res

  return {
    props: {
      ...pageData
    }
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  const { data: routes } = await getPromiseFromFetch<WPRoutes>({
    method: 'get',
    url: API.ROUTES
  })

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale
    })),
    fallback: 'blocking' // false
  }
}
